import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});

  useEffect(() => { refresh(); }, []);

  useEffect(() => {
    if (!settings?.analytics) return;
    const { ga4_id, meta_pixel_id, google_ads_id } = settings.analytics;
    const consent = localStorage.getItem("nsa_cookie_consent");
    if (consent !== "accepted") return;
    const ensureGtag = (id) => {
      if (!id) return;
      if (!window.gtag) {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
      }
      window.__nsaGtagIds = window.__nsaGtagIds || {};
      if (!window.__nsaGtagIds[id]) { window.gtag("config", id); window.__nsaGtagIds[id] = true; }
    };
    ensureGtag(ga4_id);
    ensureGtag(google_ads_id);
    const adsenseClient = settings.analytics.adsense_client || "ca-pub-4421285000577637";
    if (adsenseClient && !window.__nsaAdsense) {
      window.__nsaAdsense = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseClient}`;
      s.crossOrigin = "anonymous";
      document.head.appendChild(s);
    }
    if (meta_pixel_id && !window.fbq) {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', meta_pixel_id); window.fbq('track', 'PageView');
      /* eslint-enable */
    }
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
